export const ASSET_UPLOAD_URL = '/api/assets';

export interface FileLoaderLike {
  file: Promise<File | null>;
}

export class AppUploadAdapter {
  private xhr: XMLHttpRequest | null = null;

  constructor(private loader: FileLoaderLike) {}

  upload(): Promise<{ default: string }> {
    return this.loader.file.then((file) => {
      if (!file) {
        return Promise.reject(new Error('No file selected'));
      }
      return this.send(file);
    });
  }

  abort(): void {
    if (this.xhr) {
      this.xhr.abort();
    }
  }

  private send(file: File): Promise<{ default: string }> {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      this.xhr = xhr;
      xhr.open('POST', ASSET_UPLOAD_URL);
      xhr.withCredentials = true;
      xhr.responseType = 'json';

      xhr.addEventListener('error', () => reject(new Error('Image upload failed')));
      xhr.addEventListener('abort', () => reject());
      xhr.addEventListener('load', () => {
        const response = xhr.response as { url?: string; error?: string } | null;
        if (xhr.status < 200 || xhr.status >= 300 || !response?.url) {
          reject(new Error(response?.error || 'Image upload failed'));
          return;
        }
        resolve({ default: response.url });
      });

      const data = new FormData();
      data.append('file', file);
      xhr.send(data);
    });
  }
}

export function AppUploadAdapterPlugin(editor: { plugins: { get: (name: string) => { createUploadAdapter: (loader: FileLoaderLike) => AppUploadAdapter } } }): void {
  editor.plugins.get('FileRepository').createUploadAdapter = (loader) => new AppUploadAdapter(loader);
}
